module.exports = __webpack_public_path__ + "img/zhujianghui.fa136a90.jpg";